<div class="d-flex" [formGroup]="formGroup" *ngIf="config">
    <app-sticky-container *ngIf="improveInProgress">
        <app-loading text="Amélioration de la transcription en cours"></app-loading>
    </app-sticky-container>
    <div [style.display]="getPotentialTermsInProgress ? 'none' : 'initial'">
        <app-audio-recording class="d-block flex-grow-0 flex-shrink-0" #audioRecordingComponent
                             startRecordingIcon="microphone"
                             startRecordingTooltip="Commencer la retranscription"
                             stopRecordingTooltip="Arrêter la retranscription"
                             [hideDuration]="hideAudioRecordDuration"
                             [startRecordingManually]="true"
                             [stopRecordingManually]="true"
                             [enableSettings]="true"
                             [hideButtons]="hideAudioButtons"
                             (audioRecordStartRequestedEvent)="startTranscription()"
                             (audioRecordStopEvent)="stopTranscription()"
                             (audioRecordedEvent)="audioRecorded($event)"
                             (durationUpdatedEvent)="audioRecordDurationUpdatedEvent.emit($event)"
                             (audioChunkRecordedEvent)="audioChunkRecorded($event);">
        </app-audio-recording>
    </div>
    <app-loading [showText]="false" *ngIf="getPotentialTermsInProgress"></app-loading>
    <div class="flex-grow-0 flex-shrink-0 d-flex" style="align-items: center;" *ngIf="!transcriptionInProgress">
        <ng-container *ngIf="!hideAudioButtons">
            <mat-button-toggle-group *ngIf="config.enableConversationOption" class="icon-only" formControlName="type" style="display: flex; flex-wrap: wrap;">
                <mat-button-toggle value="SPEECH" matTooltip="Dicter le texte"><i-tabler name="message"></i-tabler></mat-button-toggle>
                <mat-button-toggle value="CONVERSATION" matTooltip="Enregistrer la conversation avec le patient"><i-tabler name="messages"></i-tabler></mat-button-toggle>
            </mat-button-toggle-group>
        </ng-container>
        <span class="link m-l-4" style="font-size: 0.8em;" *ngIf="config.conversationHTMLInstructions && formGroup.value.type === 'CONVERSATION'" (click)="openConversationInstructionsDialog();">Aides pour une analyse optimale</span>
        <span class="link m-l-4" style="font-size: 0.8em;" *ngIf="config.speechHTMLInstructions && formGroup.value.type === 'SPEECH'" (click)="openSpeechInstructionsDialog();">Aides pour une analyse optimale</span>
    </div>
    <div class="flex-grow-1 flex-shrink-1" *ngIf="config.showPreview"
        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; direction: rtl; text-align: left;">
        {{displayedTranscription}}
    </div>
</div>


